import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import styles from './index.module.less';
import Hero from './Hero';
import RecommendedArticle from './RecommendedArticle/index';
import TrustedFor from './TrustedFor/index';
import SectionWhen from './SectionWhen/index';
import useScroll from '@/context/UseScrollHeight';
import { useTranslation } from 'next-i18next';
import SectionHow from './SectionHow/index';
const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});

import { useAddAccountModal } from '@/context/AddAccountModalProvider';
import { useUserProvider } from '@/context/UserProvider';
import SectionWhat from './SectionWhat';

const MemoCommonBackContent = React.memo(CommonBackContent);

const HomeContent = ({ data }: { data: any }) => {
  const scrollHeight = useScroll();
  const { t } = useTranslation('common');
  const { openAddAccountModal } = useAddAccountModal();
  const { isLogin } = useUserProvider();
  const [heroTab, setHeroTab] = useState<'creators' | 'individuals'>('creators');
  const uploadImage = () => {
    setHeroTab('individuals');
    if (typeof window === 'undefined') {
      return;
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div>
      <Hero data={data.contentInfo.hero} isLogin={isLogin} activeTab={heroTab} onTabChange={setHeroTab} />
      <SectionWhen data={data.contentInfo['section-when']} />
      <SectionWhat data={data} />
      <SectionHow data={data} uploadImage={uploadImage} />
      <TrustedFor data={data.contentInfo['section-tools']} />
      <RecommendedArticle data={data} />
      <MemoCommonBackContent style={{ padding: '1rem', maxWidth: '1200px', margin: '0 auto' }}>
        <FreQuestion data={data} />
      </MemoCommonBackContent>
    </div>
  );
};

export default HomeContent;
